<template>
    <v-app id="inspire" style="background:#2196F3;">
        <div>
            <v-row v-if="!dMessage.show" justify="center">
                <v-overlay :value="dLoading">
                    <v-progress-circular indeterminate size="64"></v-progress-circular> Espere un momento por favor.
                </v-overlay>
                <v-card class="portrait">
                    <v-img
                        src="@/assets/images/bannerTestEgresado.jpg"
                        height="200px"
                    ></v-img>
                    <v-card-subtitle>
                        Es importante que llene la información correcta, para enviarle los avisos y oportunidades laborales que puedan existir.
                    </v-card-subtitle>

                    <v-stepper v-model="e6" vertical>
                        <!-- 1ra Pestaña ------------------------------------- -->
                        <v-form ref="refP1" lazy-validation>
                            <v-stepper-step :complete="e6 > 1" step="1">Datos Generales</v-stepper-step>
                            <v-stepper-content step="1">
                                <v-card class="mx-8 my-2">
                                    <v-card-text class="py-5" style="background:#E3F2FD">
                                        <span class="doc-card-title py-2"> 1 </span>
                                        <span class="text-h2 font-weight-black ml-3">Correo Personal (Actualizar si fuese el caso)</span>
                                    </v-card-text>
                                    <v-divider></v-divider>
                                    <v-card-actions class="py-0">
                                        <v-text-field v-model="dPriAlumno.Email" prepend-inner-icon="email" :rules="[v => !!v || 'El campo es requerido']" :maxlength="100" autocomplete="off"></v-text-field>
                                    </v-card-actions>
                                </v-card>
                                <v-card class="mx-8 my-2">
                                    <v-card-text class="py-5" style="background:#E3F2FD">
                                        <span class="doc-card-title py-2"> 2 </span>
                                        <span class="text-h2 font-weight-black ml-3">Celular (Actualizar si fuese el caso)</span>
                                    </v-card-text>
                                    <v-divider></v-divider>
                                    <v-card-actions class="py-0">
                                        <v-text-field v-model="dPriAlumno.Celular" prepend-inner-icon="smartphone" :rules="[v => !!v || 'El campo es requerido', v => (v && v.length == 9) || 'El campo debe tener 9 caracteres.']" :maxlength="9" autocomplete="off"></v-text-field>
                                    </v-card-actions>
                                </v-card>
                                <v-card class="mx-8 my-2">
                                    <v-card-text class="py-5" style="background:#E3F2FD">
                                        <span class="doc-card-title py-2"> 3 </span>
                                        <span class="text-h2 font-weight-black ml-3">Dirección (Actualizar si fuese el caso)</span>
                                    </v-card-text>
                                    <v-divider></v-divider>
                                    <v-card-actions class="py-0">
                                        <v-text-field v-model="dPriAlumno.Direccion" :rules="[v => !!v || 'El campo es requerido']" :maxlength="80" autocomplete="off"></v-text-field>
                                    </v-card-actions>
                                </v-card>
                                <v-card class="mx-8 my-2">
                                    <v-card-text class="py-5" style="background:#E3F2FD">
                                        <span class="doc-card-title py-2"> {{dP262.nro}} </span>
                                        <span class="text-h2 font-weight-black ml-3">{{dP262.Pregunta}}</span>
                                    </v-card-text>
                                    <v-divider></v-divider>
                                    <v-card-actions class="py-0">
                                        <v-radio-group  v-model="dP262.IdAlternativa" row :rules="[v => (v != 0) || 'El campo es requerido']">
                                            <v-radio label="Si" value="5" color="success"></v-radio>
                                            <v-radio label="No" value="6" color="primary"></v-radio>
                                        </v-radio-group>
                                    </v-card-actions>
                                </v-card>
                                <v-divider class="my-5"></v-divider>
                                <v-btn @click.prevent="fuNext2" color="blue-grey" class="white--text">Continuar <v-icon right>east</v-icon></v-btn>
                            </v-stepper-content>
                        </v-form>
                        <!-- 2da Pestaña ------------------------------------- -->
                        <v-form v-if="dP262.IdAlternativa!=6" ref="refP2" lazy-validation>
                            <v-stepper-step :complete="e6 > 2" step="2">Encuesta Laboral</v-stepper-step>
                            <v-stepper-content step="2">
                                <v-card class="mx-8 my-2">
                                        <v-card-text class="py-5" style="background:#E3F2FD">
                                            <span class="doc-card-title py-2"> 5 </span>
                                            <span class="text-h2 font-weight-black ml-3">RUC de la Empresa donde laboras</span>
                                        </v-card-text>
                                        <v-divider></v-divider>
                                        <v-card-actions class="py-0">
                                            <v-col cols="12" xm="12" md="6" class="pa-1 d-flex">
                                                <v-text-field @keyup.enter="fuRuc()" v-model="dtllaboral.ruc" :rules="[v => !!v || 'El campo es requerido', v => (v && v.length == 11) || 'El campo debe tener 11 caracteres.']" :maxlength="11" autocomplete="off" type="number" counter :disabled="druc_disabled"></v-text-field>
                                                <v-btn @click="fuRuc()" :loading="dIsUpdating" color="blue-grey" class="white--text"><v-icon left>search</v-icon> Buscar</v-btn>
                                                <v-btn @click="fuRefresh()" color="success" icon><v-icon>refresh</v-icon></v-btn>
                                            </v-col>
                                        </v-card-actions>
                                        <v-card-actions class="py-0">
                                            <v-col cols="12" xm="12" md="12" class="pa-1 d-flex">
                                                <h6>Si la empresa no esta registrada en la Sunat, dar click <a @click.prevent="fuNom_EmpresaEnable" class="subtitle-1">aqui</a>, y complete el nombre de la Empresa y dirección.</h6>
                                            </v-col>
                                        </v-card-actions>
                                </v-card>
                                <v-card class="mx-8 my-2">
                                    <v-card-text class="py-5" style="background:#E3F2FD">
                                        <span class="doc-card-title py-2"> 6 </span>
                                        <span class="text-h2 font-weight-black ml-3">Nombre de la Empresa donde laboras</span>
                                    </v-card-text>
                                    <v-divider></v-divider>
                                    <v-card-actions class="py-0">
                                        <v-text-field ref="refNro" v-model="dtllaboral.Nom_Empresa" :rules="[v => !!v || 'El campo es requerido']" :maxlength="200" autocomplete="off" :disabled="dNom_Empresa_disabled"></v-text-field>
                                    </v-card-actions>
                                </v-card>
                                <v-card class="mx-8 my-2">
                                    <v-card-text class="py-5" style="background:#E3F2FD">
                                        <span class="doc-card-title py-2"> 7 </span>
                                        <span class="text-h2 font-weight-black ml-3">Dirección de la Empresa donde laboras</span>
                                    </v-card-text>
                                    <v-divider></v-divider>
                                    <v-card-actions class="py-0">
                                        <v-text-field v-model="dtllaboral.Dir_Empresa" :rules="[v => !!v || 'El campo es requerido']" :maxlength="200" autocomplete="off"></v-text-field>
                                    </v-card-actions>
                                </v-card>
                                <v-card class="mx-8 my-2">
                                    <v-card-text class="py-5" style="background:#E3F2FD">
                                        <span class="doc-card-title py-2"> 8 </span>
                                        <span class="text-h2 font-weight-black ml-3">Número de teléfono o celular de la Empresa</span>
                                    </v-card-text>
                                    <v-divider></v-divider>
                                    <v-card-actions class="py-0">
                                        <v-text-field v-model="dtllaboral.Telef_ref" :rules="[v => !!v || 'El campo es requerido']" :maxlength="30" autocomplete="off"></v-text-field>
                                    </v-card-actions>
                                </v-card>
                                <v-card class="mx-8 my-2">
                                    <v-card-text class="py-5" style="background:#E3F2FD">
                                        <span class="doc-card-title py-2"> 9 </span>
                                        <span class="text-h2 font-weight-black ml-3">Puesto de trabajo en el que te desempeñas</span>
                                    </v-card-text>
                                    <v-divider></v-divider>
                                    <v-card-actions class="py-0">
                                        <v-text-field v-model="dtllaboral.Cargo" :rules="[v => !!v || 'El campo es requerido']" :maxlength="200" autocomplete="off"></v-text-field>
                                    </v-card-actions>
                                </v-card>
                                <v-card class="mx-8 my-2">
                                    <v-card-text class="py-5" style="background:#E3F2FD">
                                        <span class="doc-card-title py-2"> 10 </span>
                                        <span class="text-h2 font-weight-black ml-3">¿Qué funciones desarrollas en tu trabajo?</span>
                                    </v-card-text>
                                    <v-divider></v-divider>
                                    <v-card-actions class="py-0">
                                        <v-textarea v-model="dtllaboral.Funciones" :rules="[v => !!v || 'El campo es requerido']" :maxlength="250" autocomplete="off" auto-grow rows="1"></v-textarea>
                                    </v-card-actions>
                                </v-card>
                                <v-card class="mx-8 my-2">
                                    <v-card-text class="py-5" style="background:#E3F2FD">
                                        <span class="doc-card-title py-2"> 11 </span>
                                        <span class="text-h2 font-weight-black ml-3">¿Desde cuando aproximadamente iniciaste a laborar en tu trabajo?</span>
                                    </v-card-text>
                                    <v-divider></v-divider>
                                    <v-card-actions class="py-0">
                                        <v-menu
                                            ref="menu"
                                            v-model="menu"
                                            :close-on-content-click="false"
                                            transition="scale-transition"
                                            offset-y
                                            min-width="290px"
                                        >
                                            <template v-slot:activator="{ on }">
                                            <v-text-field
                                                v-model="dFInicio"
                                                readonly
                                                v-on="on"
                                                :rules="[v => !!v || 'El campo es requerido']"
                                            ></v-text-field>
                                            </template>
                                            <v-date-picker
                                                ref="picker"
                                                v-model="dFInicio"
                                                :max="new Date().toISOString().substr(0, 10)"
                                                min="1950-01-01"
                                                @change="save"
                                            ></v-date-picker>
                                        </v-menu>
                                    </v-card-actions>
                                </v-card>
                                <v-card class="mx-8 my-2">
                                    <v-card-text class="py-5" style="background:#E3F2FD">
                                        <span class="doc-card-title py-2"> {{dP263.nro}} </span>
                                        <span class="text-h2 font-weight-black ml-3">{{dP263.Pregunta}}</span>
                                    </v-card-text>
                                    <v-divider></v-divider>
                                    <v-card-actions class="py-0">
                                        <v-radio-group v-model="dP263.IdAlternativa" row :rules="[v => (v != 0) || 'El campo es requerido']">
                                            <v-radio label="EMPRESA PRIVADA" value="225" color="primary"></v-radio>
                                            <v-radio label="EMPRESA ESTATAL" value="224" color="primary"></v-radio>
                                            <v-radio label="MI PROPIA EMPRESA" value="226" color="primary"></v-radio>
                                            <v-radio label="OTROS" value="17" color="primary"></v-radio>
                                        </v-radio-group>
                                    </v-card-actions>
                                </v-card>
                                <v-card class="mx-8 my-2">
                                    <v-card-text class="py-5" style="background:#E3F2FD">
                                        <span class="doc-card-title py-2"> {{dP264.nro}} </span>
                                        <span class="text-h2 font-weight-black ml-3">{{dP264.Pregunta}}</span>
                                    </v-card-text>
                                    <v-divider></v-divider>
                                    <v-card-actions class="py-0">
                                        <v-radio-group v-model="dP264.IdAlternativa" row :rules="[v => (v != 0) || 'El campo es requerido']">
                                            <v-radio label="Menos de 3 Meses" value="227" color="primary"></v-radio>
                                            <v-radio label="De 3 a 12 Meses" value="228" color="primary"></v-radio>
                                            <v-radio label="Mas de 1 año" value="229" color="primary"></v-radio>
                                        </v-radio-group>
                                    </v-card-actions>
                                </v-card>
                                <v-card class="mx-8 my-2">
                                    <v-card-text class="py-5" style="background:#E3F2FD">
                                        <span class="doc-card-title py-2"> {{dP265.nro}} </span>
                                        <span class="text-h2 font-weight-black ml-3">{{dP265.Pregunta}}</span>
                                    </v-card-text>
                                    <v-divider></v-divider>
                                    <v-card-actions class="py-0">
                                        <v-radio-group  v-model="dP265.IdAlternativa" row :rules="[v => (v != 0) || 'El campo es requerido']">
                                            <v-radio label="Si" value="5" color="success"></v-radio>
                                            <v-radio label="No" value="6" color="primary"></v-radio>
                                            <v-radio label="Regularmente" value="59" color="primary"></v-radio>
                                        </v-radio-group>
                                    </v-card-actions>
                                </v-card>
                                <v-card class="mx-8 my-2">
                                    <v-card-text class="py-5" style="background:#E3F2FD">
                                        <span class="doc-card-title py-2"> {{dP266.nro}} </span>
                                        <span class="text-h2 font-weight-black ml-3">{{dP266.Pregunta}}</span>
                                    </v-card-text>
                                    <v-divider></v-divider>
                                    <v-card-actions class="py-0">
                                        <v-radio-group  v-model="dP266.IdAlternativa" row :rules="[v => (v != 0) || 'El campo es requerido']">
                                            <v-radio label="Si" value="5" color="success"></v-radio>
                                            <v-radio label="No" value="6" color="primary"></v-radio>
                                        </v-radio-group>
                                    </v-card-actions>
                                </v-card>
                                <v-card class="mx-8 my-2">
                                    <v-card-text class="py-5" style="background:#E3F2FD">
                                        <span class="doc-card-title py-2"> {{dP268.nro}} </span>
                                        <span class="text-h2 font-weight-black ml-3">{{dP268.Pregunta}}</span>
                                    </v-card-text>
                                    <v-divider></v-divider>
                                    <v-card-actions class="py-0">
                                        <v-radio-group  v-model="dP268.Especificacion" row :rules="[v => !!v || 'El campo es requerido']">
                                            <v-radio label="En Planilla" value="En Planilla" color="primary"></v-radio>
                                            <v-radio label="Recibo por Honorarios" value="Recibo por Honorarios" color="primary"></v-radio>
                                            <v-radio label="Otro" value="Otro" color="success"></v-radio>
                                        </v-radio-group>
                                    </v-card-actions>
                                </v-card>
                                <v-card class="mx-8 my-2">
                                    <v-card-text class="py-5" style="background:#E3F2FD">
                                        <span class="doc-card-title py-2"> {{dP269.nro}} </span>
                                        <span class="text-h2 font-weight-black ml-3">{{dP269.Pregunta}}</span>
                                    </v-card-text>
                                    <v-divider></v-divider>
                                    <v-card-actions class="py-0">
                                        <v-radio-group  v-model="dP269.IdAlternativa" row :rules="[v => (v != 0) || 'El campo es requerido']">
                                            <v-radio label="Menos de 2 meses" value="230" color="primary"></v-radio>
                                            <v-radio label="De 2 a 6 meses" value="231" color="primary"></v-radio>
                                            <v-radio label="Más de 6 meses" value="232" color="primary"></v-radio>
                                        </v-radio-group>
                                    </v-card-actions>
                                </v-card>
                                <v-card class="mx-8 my-2">
                                    <v-card-text class="py-5" style="background:#E3F2FD">
                                        <span class="doc-card-title py-2"> {{dP270.nro}} </span>
                                        <span class="text-h2 font-weight-black ml-3">{{dP270.Pregunta}}</span>
                                    </v-card-text>
                                    <v-divider></v-divider>
                                    <v-card-actions class="py-0">
                                        <v-radio-group  v-model="dP270.IdAlternativa" row :rules="[v => (v != 0) || 'El campo es requerido']">
                                            <v-radio label="Menos de S/. 1200." value="233" color="primary"></v-radio>
                                            <v-radio label="Entre S/. 1200 y S/. 2000" value="234" color="primary"></v-radio>
                                            <v-radio label="Más de S/. 2000" value="235" color="primary"></v-radio>
                                        </v-radio-group>
                                    </v-card-actions>
                                </v-card>
                                <v-divider class="my-5"></v-divider>
                                <v-btn @click="e6 = 1"><v-icon left>west</v-icon> Atras</v-btn>
                                <v-btn @click.prevent="fuNext3" color="blue-grey" class="white--text">Continuar <v-icon right>east</v-icon></v-btn>
                            </v-stepper-content>
                        </v-form>
                        <!-- 3ra Pestaña ------------------------------------- -->
                        <v-form ref="refP3" lazy-validation>
                            <v-stepper-step :complete="e6 > 3" step="3">Encuesta Satisfacción</v-stepper-step>
                            <v-stepper-content step="3">
                                <v-card class="mx-8 my-2">
                                    <v-card-text class="py-5" style="background:#E3F2FD">
                                        <span class="doc-card-title py-2"> {{dP271.nro}} </span>
                                        <span class="text-h2 font-weight-black ml-3">{{dP271.Pregunta}}</span>
                                    </v-card-text>
                                    <v-divider></v-divider>
                                    <v-card-actions class="py-0">
                                        <v-textarea v-model="dP271.Especificacion" :rules="[v => !!v || 'El campo es requerido']" :maxlength="1050" autocomplete="off" auto-grow rows="1"></v-textarea>
                                    </v-card-actions>
                                </v-card>
                                <v-card class="mx-8 my-2">
                                    <v-card-text class="py-5" style="background:#E3F2FD">
                                        <span class="doc-card-title py-2"> {{dP273.nro}} </span>
                                        <span class="text-h2 font-weight-black ml-3">{{dP273.Pregunta}}</span>
                                    </v-card-text>
                                    <v-divider></v-divider>
                                    <v-card-actions class="py-0">
                                        <v-textarea v-model="dP273.Especificacion" :rules="[v => !!v || 'El campo es requerido']" :maxlength="1050" autocomplete="off" auto-grow rows="1"></v-textarea>
                                    </v-card-actions>
                                </v-card>
                                <v-card class="mx-8 my-2">
                                    <v-card-text class="py-5" style="background:#E3F2FD">
                                        <span class="doc-card-title py-2"> {{dP274.nro}} </span>
                                        <span class="text-h2 font-weight-black ml-3">{{dP274.Pregunta}}</span>
                                    </v-card-text>
                                    <v-divider></v-divider>
                                    <v-card-actions class="py-0">
                                        <v-textarea v-model="dP274.Especificacion" :rules="[v => !!v || 'El campo es requerido']" :maxlength="1050" autocomplete="off" auto-grow rows="1"></v-textarea>
                                    </v-card-actions>
                                </v-card>
                                <v-card class="mx-8 my-2">
                                    <v-card-text class="py-5" style="background:#E3F2FD">
                                        <span class="doc-card-title py-2"> {{dP413.nro}} </span>
                                        <span class="text-h2 font-weight-black ml-3">{{dP413.Pregunta}}</span>
                                    </v-card-text>
                                    <v-divider></v-divider>
                                    <v-card-actions class="py-0">
                                        <v-radio-group v-model="dP413.IdAlternativa" row :rules="[v => (v != 0) || 'El campo es requerido']">
                                            <v-radio label="Muy Satisfecho" value="196" color="primary"></v-radio>
                                            <v-radio label="Satisfecho" value="197" color="primary"></v-radio>
                                            <v-radio label="Poco Satisfecho" value="198" color="primary"></v-radio>
                                            <v-radio label="Insatisfecho" value="199" color="primary"></v-radio>
                                        </v-radio-group>
                                    </v-card-actions>
                                </v-card>
                                <v-card class="mx-8 my-2">
                                    <v-card-text class="py-5" style="background:#E3F2FD">
                                        <span class="doc-card-title py-2"> {{dP414.nro}} </span>
                                        <span class="text-h2 font-weight-black ml-3">{{dP414.Pregunta}}</span>
                                    </v-card-text>
                                    <v-divider></v-divider>
                                    <v-card-actions class="py-0">
                                        <v-textarea v-model="dP414.Especificacion" :rules="[v => !!v || 'El campo es requerido']" :maxlength="1050" autocomplete="off" auto-grow rows="1"></v-textarea>
                                    </v-card-actions>
                                </v-card>
                                <v-card class="mx-8 my-2">
                                    <v-card-text class="py-5" style="background:#E3F2FD">
                                        <span class="doc-card-title py-2"> {{dP102.nro}} </span>
                                        <span class="text-h2 font-weight-black ml-3">{{dP102.Pregunta}}</span>
                                    </v-card-text>
                                    <v-divider></v-divider>
                                    <v-card-actions class="py-0">
                                        <v-radio-group  v-model="dP102.IdAlternativa" row :rules="[v => (v != 0) || 'El campo es requerido']">
                                            <v-radio label="Si" value="5" color="success"></v-radio>
                                            <v-radio label="No" value="6" color="primary"></v-radio>
                                        </v-radio-group>
                                    </v-card-actions>
                                </v-card>
                                <v-divider class="my-5"></v-divider>
                                <v-btn @click.prevent="fuBack2"><v-icon left>west</v-icon> Atras</v-btn>
                                <v-btn @click.prevent="fuSave" :loading="dIsUpdating" color="primary">Guardar <v-icon right>save</v-icon></v-btn>
                            </v-stepper-content>
                        </v-form>
                    </v-stepper>
                    <!-- <p>{{dP262}}</p>
                    <p>{{dP263}}</p>
                    <p>{{dP264}}</p>
                    <p>{{dP265}}</p>
                    <p>{{dP266}}</p>
                    <p>{{dP268}}</p>
                    <p>{{dP269}}</p>
                    <p>{{dP270}}</p>
                    <p>{{dP271}}</p>
                    <p>{{dP273}}</p>
                    <p>{{dP274}}</p> -->
                </v-card>
            </v-row>
            <v-row v-else justify="center">
                <div class="bg-blue text-white text-center q-pa-md flex flex-center">
                    <div>
                        <div>
                            <v-icon size="260" dark>{{dMessage.icon}}</v-icon>
                        </div>
                        <p class="text-h2" style="font-size: 5vh; opacity:.8; color:white" v-html="dMessage.text">
                        </p>
                    </div>
                </div>
            </v-row>
        </div>
        <v-snackbar v-model="dSnackbar.value" :color="dSnackbar.color">{{dSnackbar.text}}
            <v-btn text @click="dSnackbar.value = false"> Cerrar </v-btn>
        </v-snackbar>
    </v-app>    
</template>
<script>
import moment from 'moment';
import gql from 'graphql-tag';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';

export default {
    name: 'TestEgresado',
    mounted(){
        if (!this.$route.params.pIdAlumno){
            this.dtllaboral.IdAlumno = this.$route.params.pIdAlumno;
            this.dMessage = {
                show: true,
                text:"Hubo un error<br/>Pruebe actualizar la pagina o llamar al nro. 984130103",
                icon: "cancel"
            }
        } else {
            this.fuLoad();
        }
    },
    data: () => ({
        e6: 1,
        dIdMatricula: '',
        dIsUpdating: false,
        dFInicio: '',
        menu: false,
        dLoading : false,
        dMessage: {
            show: false,
            text: "",
            icon: ""
        },
        dSnackbar: {
            value: false,
            color: "red",
            text: "",
        },
        dValid: false,
        dPriAlumno: {
            Email: '',
            Celular: '',
            FechaMod: '',
            OperModif: 'egresado',
            Direccion: '',
        },
        dtllaboral: {
            IdAlumno: '',
            Nom_Empresa: '',
            Dir_Empresa: '',
            Cargo: '',
            F_Inicio: '',
            Funciones: '',
            Referencia: '.',
            Telef_ref: '',
            ruc: '',
        },
        druc_disabled: false,
        dNom_Empresa_disabled: true,
        dP262: { IdPregunta: 262, IdAlternativa: '0', Especificacion:'', nro: 4, Pregunta: '¿Te encuentras laborando actualmente?'},
        dP263: { IdPregunta: 263, IdAlternativa: '0', Especificacion:'', nro: 12, Pregunta: '¿En qué tipo de Empresa trabajas?'},
        dP264: { IdPregunta: 264, IdAlternativa: '0', Especificacion:'', nro: 13, Pregunta: '¿Cuánto tiempo más te gustaría seguir en tu trabajo actual?'},
        dP265: { IdPregunta: 265, IdAlternativa: '0', Especificacion:'', nro: 14, Pregunta: '¿Crees que estás trabajando en alguna especialidad del Programa de Estudios que estudiaste en KHIPU?'},
        dP266: { IdPregunta: 266, IdAlternativa: '0', Especificacion:'', nro: 15, Pregunta: '¿Tu Título u otra Certificación de KHIPU, te ayudó directamente a obtener tu trabajo actual?'},
        dP268: { IdPregunta: 268, IdAlternativa: '0', Especificacion:'', nro: 16, Pregunta: 'Tu modalidad de trabajo:'},
        dP269: { IdPregunta: 269, IdAlternativa: '0', Especificacion:'', nro: 17, Pregunta: '¿Cuánto tiempo estuviste desempleado antes de encontrar tu trabajo actual?'},
        dP270: { IdPregunta: 270, IdAlternativa: '0', Especificacion:'', nro: 18, Pregunta: '¿En qué rango se encuentra tu salario mensual actualmente?'},
        dP271: { IdPregunta: 271, IdAlternativa: '0', Especificacion:'', nro: 19, Pregunta: 'Describe brevemente que cursos debimos haberte enseñado'},
        dP273: { IdPregunta: 273, IdAlternativa: '0', Especificacion:'', nro: 20, Pregunta: 'Como egresado(a), ¿qué esperas ahora de KHIPU?, ¿en qué podemos ayudarte?'},
        dP274: { IdPregunta: 274, IdAlternativa: '0', Especificacion:'', nro: 21, Pregunta: 'Como egresado(a), ¿qué cursos piensas que serían importantes para complementar tu formación profesional?'},
        dP413: { IdPregunta: 413, IdAlternativa: '0', Especificacion:'', nro: 22, Pregunta: '¿Cuán satisfecho te encuentras con la infraestructura y otros servicios de KHIPU?'},
        dP414: { IdPregunta: 414, IdAlternativa: '0', Especificacion:'', nro: 23, Pregunta: '¿Por qué pusiste esa calificación en la escala del punto anterior?'},
        dP102: { IdPregunta: 102, IdAlternativa: '0', Especificacion:'', nro: 24, Pregunta: '¿Recomendarías a otras personas estudiar en nuestra institución?'},
    }),
    watch: {
        menu (val) {
            val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
        },
        dFInicio(val){
            if(val)
                this.dtllaboral.F_Inicio = val.split("-").join("");
        },
    },
    methods: {
        save (date) {
            this.$refs.menu.save(date)
        },
        async fuLoad() {
            this.dLoading = true;
            try {
                const response = await this.$apollo.query({
                    query: gql`query prialumno($IdAlumno: ID!, $token: String){
                        prialumno(IdAlumno:$IdAlumno, token: $token){
                            Celular
                            Email
                            Direccion
                        }
                        matmatriculaLast(IdAlumno: $IdAlumno){
                            IdMatricula
                        }
                    }`,
                    variables: {
                        IdAlumno: this.$route.params.pIdAlumno,
                        token: new Date().toISOString()
                    }
                })
                this.dPriAlumno.Celular = response.data.prialumno.Celular;
                this.dPriAlumno.Email = response.data.prialumno.Email;
                this.dPriAlumno.Direccion = response.data.prialumno.Direccion;
                this.dIdMatricula = response.data.matmatriculaLast[0].IdMatricula
                // if(response.data.prialumno.length){
                //     console.log(response.data.prialumno);
                // }
            } catch (error) {
                console.log(error);
            } finally {
                this.dLoading = false;
            }
        },
        fuSave(){
            this.dtllaboral.IdAlumno = this.$route.params.pIdAlumno;
            if(!this.$refs.refP3.validate()){
                this.dSnackbar = {
                    value: true,
                    color: "red",
                    text: "Revise el formulario, faltan preguntas por contestar.",
                }
            } else {
                this.dPriAlumno.FechaMod = moment().format("YYYYMMDD HH:mm:ss");
                this.fuAlumnoUpdate();
            }
        },
        async fuAlumnoUpdate () {
            let arrayPreguntas = [];
            arrayPreguntas.push(this.dP262);
            if(this.dP262.IdAlternativa==5){
                arrayPreguntas.push(this.dP263);
                arrayPreguntas.push(this.dP264);
                arrayPreguntas.push(this.dP265);
                arrayPreguntas.push(this.dP266);
                arrayPreguntas.push(this.dP268);
                arrayPreguntas.push(this.dP269);
                arrayPreguntas.push(this.dP270);
            }
            arrayPreguntas.push(this.dP271);
            arrayPreguntas.push(this.dP273);
            arrayPreguntas.push(this.dP274);
            arrayPreguntas.push(this.dP413);
            arrayPreguntas.push(this.dP414);
            arrayPreguntas.push(this.dP102);

            let varray=JSON.stringify(arrayPreguntas);
            this.dtllaboral.IdAlumno = this.$route.params.pIdAlumno;
            try {
                this.dIsUpdating = true;
                var response;
                if(this.dP262.IdAlternativa==5){
                    response = await this.$apollo.mutate({
                        mutation: gql`mutation prialumnoUpdate($IdAlumno: ID!, $input: prialumnoUpdateInput!, $inputdtllaboralCreate: dtllaboralCreateInput!, $IdMatricula: Int!, $array: String!){
                            prialumnoUpdate(IdAlumno: $IdAlumno, input: $input){
                                IdAlumno
                            }
                            dtllaboralCreate(input: $inputdtllaboralCreate){
                                IdLaboral
                            }
                            cceencuestaCreateArray(IdMatricula:$IdMatricula, array: $array){
                                success
                                message
                            }
                        }`,
                        variables: {
                            IdAlumno: this.$route.params.pIdAlumno,
                            input: this.dPriAlumno,
                            inputdtllaboralCreate: this.dtllaboral,
                            IdMatricula: this.dIdMatricula,
                            array: varray,
                        }
                    });
                } else {
                    response = await this.$apollo.mutate({
                        mutation: gql`mutation prialumnoUpdate($IdAlumno: ID!, $input: prialumnoUpdateInput!, $IdMatricula: Int!, $array: String!){
                            prialumnoUpdate(IdAlumno: $IdAlumno, input: $input){
                                IdAlumno
                            }
                            cceencuestaCreateArray(IdMatricula:$IdMatricula, array: $array){
                                success
                                message
                            }
                        }`,
                        variables: {
                            IdAlumno: this.$route.params.pIdAlumno,
                            input: this.dPriAlumno,
                            IdMatricula: this.dIdMatricula,
                            array: varray,
                        }
                    });
                }
                if(response.data){
                    this.dMessage = {
                        show: true,
                        text:"La encuesta se envió correctamente.",
                        icon: "check_circle"
                    }
                } else {
                    console.log("No se envio la encuesta.");
                    Swal.fire('¡ ERROR !', 'Error de conexión.', 'error');
                }
            } catch (error) {
                console.log(error);
                Swal.fire('¡ ERROR !', 'Error de conexión.', 'error');
            } finally {
                this.dIsUpdating = false;
            }
        },
        fuNext2(){
            if(!this.$refs.refP1.validate()){
                this.dSnackbar = {
                    value: true,
                    color: "red",
                    text: "Revise el formulario, faltan preguntas por contestar.",
                }
            } else {
                if(this.dP262.IdAlternativa==5)
                    this.e6 = 2;
                else
                    this.e6 = 3;
            }
        },
        fuNext3(){
            if(!this.$refs.refP2.validate()){
                this.dSnackbar = {
                    value: true,
                    color: "red",
                    text: "Revise el formulario, faltan preguntas por contestar.",
                }
            } else {
                this.e6 = 3;
            }
        },
        fuBack2(){
            if(this.dP262.IdAlternativa==5)
                this.e6 = 2;
            else
                this.e6 = 1;
        },
        async fuRuc() {
            if(this.dtllaboral.ruc.length !=11){
                Swal.fire('¡ ERROR !', 'El RUC debe tener 11 caracteres.', 'error');
            } else {
                this.dtllaboral.Nom_Empresa = "";
                this.dtllaboral.Dir_Empresa = "";
                this.dNom_Empresa_disabled = true;
                this.druc_disabled = true;
                this.dIsUpdating = true;
                try {
                    const response = await this.$apollo.query({
                        query: gql`query sunatByRuc($ruc: String!){
                            sunatByRuc(ruc: $ruc){
                                nombre
                                direccion
                            }
                        }`,
                        variables: {
                            ruc: this.dtllaboral.ruc,
                        }
                    })
                    console.log(response.data);

                    if(response.data.sunatByRuc.nombre ==""){
                        this.dSnackbar = {
                            value: true,
                            color: "red",
                            text: "No se encontró el RUC.",
                        }
                    } else {
                        this.dtllaboral.Nom_Empresa = response.data.sunatByRuc.nombre;
                        this.dtllaboral.Dir_Empresa = response.data.sunatByRuc.direccion;

                        this.dSnackbar = {
                            value: true,
                            color: "green",
                            text: "Se encontró el RUC.",
                        }
                    }
                } catch (error) {
                    console.log(error);
                    this.dSnackbar = {
                        value: true,
                        color: "red",
                        text: "No se encontró el RUC.",
                    }
                } finally {
                    this.dIsUpdating = false;
                }
            }
        },
        fuNom_EmpresaEnable(){
            this.dtllaboral.ruc = '10000000000';
            this.dNom_Empresa_disabled = false;
            this.$refs.refNro.focus();
            this.druc_disabled = true;
        },
        fuRefresh(){
            this.druc_disabled = false;
            this.dNom_Empresa_disabled = true;
            this.dtllaboral.ruc = '';
            this.dtllaboral.Nom_Empresa = '';
            this.dtllaboral.Dir_Empresa = '';
        }
    }
}
</script>
<style scoped>
    .portrait.v-card {
        margin: 0 auto;
        max-width: 800px;
        width: 100%;
    }
    .doc-card-title {
        margin-left: -24px;
        padding: 2px 10px 2px 15px;
        background: #42A5F5;
        color: #ffffff;
        position: relative;
        border-radius: 3px 5px 5px 0;
        width: 100;
    }
</style>
